import { render, staticRenderFns } from "./AddChannelMarkers.vue?vue&type=template&id=8f59c426&scoped=true"
import script from "./AddChannelMarkers.vue?vue&type=script&lang=js"
export * from "./AddChannelMarkers.vue?vue&type=script&lang=js"
import style0 from "./AddChannelMarkers.vue?vue&type=style&index=0&id=8f59c426&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f59c426",
  null
  
)

export default component.exports